import { useQuery } from "@tanstack/react-query";
import { useUniversalAuth } from "@west-tennessee-consulting/ui";

export function useTemplateSchema(templateId: string) {
  const { session } = useUniversalAuth();

  return useQuery({
    queryKey: ["template-schema", templateId],
    queryFn: async () => {
      try {
        const token = session?.access_token;
        if (!token) {
          throw new Error("Authentication required");
        }

        const response = await fetch(`/api/contracts/schema/${templateId}`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

        if (!response.ok) {
          throw new Error(`Failed to fetch schema: ${response.status} ${response.statusText}`);
        }

        const apiResponse = await response.json();
        return apiResponse.data;
      } catch (error) {
        console.error("Error fetching template schema:", error);
        throw error;
      }
    },
    enabled: !!session?.access_token && !!templateId,
    staleTime: 10 * 60 * 1000, // 10 minutes
  });
}
